import styled from '@emotion/styled'

export default styled.ul`
  color: inherit;
`
